import { useEffect, useState } from 'react';
import { API_MODE } from '../api/client.js';

type Health = { ok: boolean; provider?: string; modelConfigured?: boolean };

/**
 * Slice 8 起：存储/模型凭证都在服务端，前端不收集，所以徽标改为反映「服务端就绪度」。
 * mock 模式：永远「演示模式」。
 * real 模式：打 /health 看 modelConfigured。
 */
export function StatusBadge() {
  const [health, setHealth] = useState<Health | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (API_MODE !== 'real') return;
    const base = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '');
    fetch(base + '/health')
      .then((r) => r.json())
      .then((h: Health) => setHealth(h))
      .catch(() => setFailed(true));
  }, []);

  if (API_MODE !== 'real') {
    return <span className="status-badge pending"><span className="dot" />演示模式</span>;
  }
  if (failed) {
    return <span className="status-badge pending"><span className="dot" />服务未连接</span>;
  }
  if (!health) {
    return <span className="status-badge pending"><span className="dot" />检测中…</span>;
  }
  const ready = !!health.modelConfigured;
  return (
    <span className={'status-badge' + (ready ? ' ok' : ' pending')}>
      <span className="dot" />
      {ready ? `就绪 · ${health.provider}` : `模型待配置 · ${health.provider ?? '?'}`}
    </span>
  );
}
